import {resourceToUserEvents} from '@cohort/merchants/apps';
import AdminPage from '@cohort/merchants/components/AdminPage';
import NotificationsSettingsList from '@cohort/merchants/components/notifications/NotificationsSettingsList';
import SectionSeparator from '@cohort/merchants/components/SectionSeparator';
import type FeatureFlags from '@cohort/merchants/featureFlags';
import {useCurrentPerk} from '@cohort/merchants/hooks/contexts/currentPerk';
import {useFlags} from 'launchdarkly-react-client-sdk';
import {useTranslation} from 'react-i18next';
import {Navigate} from 'react-router-dom';

const PerkNotificationsPage: React.FC = () => {
  const {t} = useTranslation('pages', {keyPrefix: 'perks.perk.notifications.page'});
  const {featureNotifications} = useFlags<FeatureFlags>();
  const perk = useCurrentPerk();

  if (!featureNotifications) {
    return <Navigate to="/not-found" replace />;
  }
  const headerConfig = {
    title: t('title'),
    subtitle: t('subtitle'),
  };

  const perkUserEvents = resourceToUserEvents['perk'];
  const perkUserEventsIds = perkUserEvents.map(userEvent => userEvent.spec.id);

  return (
    <AdminPage header={headerConfig} className="space-y-10">
      <SectionSeparator />
      <div className="mt-8">
        <NotificationsSettingsList
          userEventIds={perkUserEventsIds}
          resourceType="perk"
          resourceId={perk.id}
        />
      </div>
    </AdminPage>
  );
};

export default PerkNotificationsPage;
